angular.module('directives.dashboard').controller('wgtSettingsMultipleLocations',
    ['$scope', '$rootScope',
        function ($scope, $rootScope) {
            if ($scope.item.setting === undefined) {
                $scope.selectedSettingItems = '';
            } else {
                var selectedLocationIds = $scope.item.setting.locationIds;
                
                if(angular.isString($scope.item.setting)){
                    selectedLocationIds = JSON.parse($scope.item.setting).locationIds;
                }

                $scope.selectedSettingItems = [];

                _.forEach($scope.currentUser.locations, function(loc){
                    if(_.some(selectedLocationIds, function(id){ return parseInt(id) === loc.id })){
                        $scope.selectedSettingItems.push(loc);
                    }
                })
            }
            $scope.saveSettings = function () {
                if ($scope.selectedSettingItems === null) {
                    $scope.$parent.selectedLocations = [];
                } else {     

                    var settingsObject = { locationIds : [] };
                    _.forEach($scope.currentUser.locations, function(loc){
                        if(_.some($scope.selectedSettingItems, function(item){ return item.id === loc.id })){
                            settingsObject.locationIds.push(loc.id);
                        }
                    })

                    $scope.$parent.selectedLocations = angular.copy($scope.selectedSettingItems);
                    $scope.selectedSettingItems = settingsObject;
                }
                $scope.item.setting = $scope.selectedSettingItems;
                if ($scope.$parent) {
                    if ($scope.$parent.loadWidget) {
                        $scope.$parent.loadWidget();
                    }
                }
                $rootScope.$emit("widget.changed", $scope.item);

                $scope.$close();
            };
        }]);
